import React, { useEffect, useRef, useState } from "react";
import "./custom-header.m.css";
import PvLogoCok from "../../../atoms/other-icons/PvLogoCok";
import CokLogo from "../../../atoms/other-icons/CokLogo";
import { Link } from "@quintype/components";
import CustomSignin from "./custom-signin";
import { useSelector } from "react-redux";
import { get, throttle } from "lodash";
import CustomHamburgerMenu from "./custom-hamburger-menu";
import MyAccount from "../../../atoms/my-account";
import Modal from "../../../atoms/modal";
import CustomMyAccountButton from "./custom-my-account-button";
import useDevice from "../../../helper/custom-hook/useDevice";
import User from "../../../atoms/other-icons/User";
import MyAccountButton from "../../../atoms/my-account-button";
import HamburgerMenu from "../../../atoms/hamburger-menu";
import HamburgerSearch from "../../../atoms/other-icons/HamburgerSearch";

const CustomHeader = ({
  isHardcodedHeader,
  getDropdownList,
  isMobileHamburger,
  toggleHandler,
  isHamburgerMenuOpen,
  closeModal,
  isOpen,
  onAccountHandler
}) => {
  const navRef = useRef();
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));

  const deviceIsMobile = useDevice();

  // Fallback mobile detection using window width
  const [windowIsMobile, setWindowIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window !== "undefined") {
        setWindowIsMobile(window.innerWidth < 1025);
      }
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Priority: isMobileHamburger prop > deviceIsMobile hook > window width fallback
  const isMobile = isMobileHamburger !== undefined && isMobileHamburger !== null
    ? isMobileHamburger
    : (deviceIsMobile !== null && deviceIsMobile !== undefined
      ? deviceIsMobile
      : windowIsMobile);

  const [redirectURL, setRedirectUrl] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const secondaryMenus = useSelector((state) => get(state, ["qt", "data", "navigationMenu", "cokMenus"], []));
  const HeaderValues = {
    cok2025: {
      headerBg: "#a5161c",
      logoLink: "/food/cuisines-of-karnataka",
      logoUrl: "https://thumbor-stg.assettype.com/prajavani2/2025-08-04/5wvbptt4/coklogo",
      menus: secondaryMenus
    },
    festivals: {
      headerBg: "#5D0034",
      logoLink: "/festivals-of-karnataka/deepawali-deepamale",
      logoUrl: "https://thumbor-stg.assettype.com/prajavani2/2025-10-17/87n7k0z3/Festival",
      menus: []
    },
    "Canara-Robeco": {
      headerBg: "#333333",
      topLogoPrimary: "https://thumbor-stg.assettype.com/prajavani2/2026-01-08/dplmxb8a/Group-5.png",
      topLogoSecondary: "https://thumbor-stg.assettype.com/prajavani2/2026-01-07/3y7xd19f/Group.png?w=400&q=60",
      bottomText: "ಹೂಡಿಕೆದಾರರ ಶಿಕ್ಷಣ ಮತ್ತು ಜಾಗೃತಿ ಉಪಕ್ರಮ",
      menus: secondaryMenus
    }
  };
  useEffect(() => {
    setRedirectUrl(window.location.href);

    if (isHardcodedHeader === "Canara-Robeco") {
      setIsSticky(false);
    }

    window.addEventListener("scroll", throttle(getScroll, 250));
    return () => {
      window.removeEventListener("scroll", throttle(getScroll, 250));
    };
  }, []);

  const getScroll = () => {
    if (isHardcodedHeader === "Canara-Robeco") {
      return;
    }

    const valOfHeader = isMobile ? 99 : 116;
    if (typeof window !== "undefined") {
      if (window.scrollY > valOfHeader) {
        setIsSticky(true);
      }
      if (window.scrollY < valOfHeader) {
        setIsSticky(false);
      }
    }
  };

  const signinHandler = () => {
    if (window) {
      window.dataLayer.push({
        event: "SSO_Page_Open"
      });
    }

    window.location.href = `${ssoEndpoint}/auth?redirectUrl=${redirectURL}`;
  };

  return (
    <>
      {isHardcodedHeader === "Canara-Robeco" && !isMobile ? (
        <nav styleName="st-header-container" className="st-header-container">
          <div styleName="st-header-top">
            <div className="container" styleName="st-header-top-container">
              <a href="/" styleName="st-header-logo-left">
                <img src={HeaderValues[isHardcodedHeader]?.topLogoPrimary} alt="Logo 1" />
              </a>
              <a href="/" styleName="st-header-logo-center" onClick={(e) => e.preventDefault()}>
                <img src={HeaderValues[isHardcodedHeader]?.topLogoSecondary} alt="Logo 2" />
              </a>
              <div styleName="st-header-sign-hamburger">
                {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
                  <CustomSignin color="#ffffff" signinHandler={signinHandler} />
                ) : (
                  <CustomMyAccountButton
                    color={HeaderValues[isHardcodedHeader]?.headerBg}
                    onAccountHandler={onAccountHandler}
                  />
                )}

                <Modal onClose={closeModal} isOpen={isOpen}>
                  <MyAccount closeModal={closeModal} />
                </Modal>
                <div styleName="st-header-hamburger">
                  <button
                    aria-label="Hamburger Menu"
                    onClick={toggleHandler}
                    styleName="st-hamburger-button"
                  >
                    <HamburgerSearch color="black" width="32" height="22" />
                  </button>
                </div>
                {getDropdownList()}
              </div>
            </div>
          </div>
          <div styleName="st-header-bottom">
            <div styleName="st-header-bottom-container">
              <span styleName="st-header-bottom-text">{HeaderValues[isHardcodedHeader]?.bottomText}</span>
            </div>
          </div>
        </nav>
      ) : isHardcodedHeader === "Canara-Robeco" && isMobile ? (
        <nav styleName="st-header-container-mobile">
          <div styleName="st-header-mobile-row">
            <a href="/" styleName="st-header-mobile-logo1">
              <img src={HeaderValues[isHardcodedHeader]?.topLogoPrimary} alt="Logo 1" />
            </a>
            <a href="/" styleName="st-header-mobile-logo2" onClick={(e) => e.preventDefault()}>
              <img src={HeaderValues[isHardcodedHeader]?.topLogoSecondary} alt="Logo 2" />
            </a>
            <div styleName="st-header-mobile-actions">
              {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
                <button onClick={signinHandler} styleName="st-header-mobile-signin">
                  <User width="12" height="13" color="white" />
                </button>
              ) : (
                <MyAccountButton onAccountHandler={onAccountHandler} />
              )}
              <Modal onClose={closeModal} isOpen={isOpen}>
                <MyAccount closeModal={closeModal} />
              </Modal>
              <div styleName="st-header-mobile-hamburger">
                <button
                  aria-label="Hamburger Menu"
                  onClick={toggleHandler}
                  styleName="st-hamburger-button"
                >
                  <HamburgerSearch color="black" width="24" height="16" />
                </button>
              </div>
              {getDropdownList()}
            </div>
          </div>
          <div styleName="st-header-mobile-bottom">
            <span styleName="st-header-mobile-bottom-text">{HeaderValues[isHardcodedHeader]?.bottomText}</span>
          </div>
        </nav>
      ) : isSticky ? (
        isMobile ? (
          <nav styleName="sticky-container">
            <div styleName="secondary-wrapper-sticky">
              {HeaderValues[isHardcodedHeader]?.menus.length > 0
                ? HeaderValues[isHardcodedHeader]?.menus?.map((menu) => (
                  <Link href={menu.url} id={menu.id}>
                    <span styleName="menu">{menu.title}</span>
                  </Link>
                ))
                : null}
            </div>
            <div styleName="sticky-container-right">
              {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
                <button onClick={signinHandler} styleName="sign-in-only-icon">
                  <User width="16" height="16" />
                </button>
              ) : (
                <MyAccountButton onAccountHandler={onAccountHandler} />
              )}
              <Modal onClose={closeModal} isOpen={isOpen}>
                <MyAccount closeModal={closeModal} />
              </Modal>

              <CustomHamburgerMenu
                isMobileHamburger={isMobileHamburger}
                onMenuToggle={() => toggleHandler()}
                isMegaMenuOpen={isHamburgerMenuOpen}
              />
              {getDropdownList()}
            </div>
          </nav>
        ) : (
          <nav styleName="sticky-container" ref={navRef}>
            <div styleName="sticky-container-left">
              <HamburgerMenu
                isMobileHamburger={false}
                onMenuToggle={() => toggleHandler()}
                isMegaMenuOpen={isHamburgerMenuOpen}
              />
              {getDropdownList()}
              <Link href="/" styleName="pv-logo">
                <img src="/icons/lstlogo.png" />
              </Link>

              <div styleName="secondary-wrapper-sticky">
                {HeaderValues[isHardcodedHeader]?.menus.length > 0
                  ? HeaderValues[isHardcodedHeader]?.menus?.map((menu) => (
                    <Link href={menu.url} id={menu.id}>
                      <span styleName="menu">{menu.title}</span>
                    </Link>
                  ))
                  : null}
              </div>
            </div>
            {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
              <button onClick={signinHandler} styleName="sign-in">
                <User color="black" width="16" height="16" />
                Sign in
              </button>
            ) : (
              <MyAccountButton onAccountHandler={onAccountHandler} />
            )}
            <Modal onClose={closeModal} isOpen={isOpen}>
              <MyAccount closeModal={closeModal} />
            </Modal>
          </nav>
        )
      ) : (
        <nav styleName="cok-header-container">
          <div
            styleName="cok-header-main-header"
            style={{ backgroundColor: HeaderValues[isHardcodedHeader]?.headerBg }}
          >
            <div styleName="cok-header-main-header-container" className="container">
              <a href="/" styleName="cok-header-main-logo">
                <PvLogoCok />
              </a>
              <Link href={HeaderValues[isHardcodedHeader]?.logoLink} styleName="cok-header-cok-logo">
                <img src={HeaderValues[isHardcodedHeader]?.logoUrl} />
              </Link>
              <div styleName="cok-header-sign-hamburger">
                {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
                  <CustomSignin color={HeaderValues[isHardcodedHeader]?.headerBg} signinHandler={signinHandler} />
                ) : (
                  <CustomMyAccountButton
                    color={HeaderValues[isHardcodedHeader]?.headerBg}
                    onAccountHandler={onAccountHandler}
                  />
                )}

                <Modal onClose={closeModal} isOpen={isOpen}>
                  <MyAccount closeModal={closeModal} />
                </Modal>
                <div styleName="cok-header-hamburger">
                  <CustomHamburgerMenu
                    isMobileHamburger={isMobileHamburger}
                    onMenuToggle={() => toggleHandler()}
                    isMegaMenuOpen={isHamburgerMenuOpen}
                  />
                </div>
                {getDropdownList()}
              </div>
            </div>
          </div>
          <div styleName="cok-header-sub-header">
            <div className="container" styleName="cok-header-sub-header-container">
              <div styleName="secondary-wrapper">
                {HeaderValues[isHardcodedHeader]?.menus.length > 0
                  ? HeaderValues[isHardcodedHeader]?.menus?.map((menu) => (
                    <Link href={menu.url} id={menu.id}>
                      <span styleName="menu">{menu.title}</span>
                    </Link>
                  ))
                  : null}
              </div>
            </div>
          </div>
        </nav>
      )}
    </>
  );
};

export default CustomHeader;
